<div class="card">
    <div #parteDiarioRef class="card-body">
      <div class="row">
        <div class="mb-3 col-md-12">
          <div class="row">
            <div class="col-md-2">
              <img id="logo-ypf" src="/assets/images/logoypf.png" />
            </div>
            <div class="col-md-8 text-center">
              <h3>Aeroplanta {{ this.aeroplanta?.nombre }}</h3>
            </div>
            <div class="col-md-2">
              Fecha Reporte: <b>{{ this.fechaHoraReporte | date:"d'/'MM'/'y" }}</b>
              <ng-container *ngIf="!reporteParteDiario">
                <button class="btn btn-primary" [disabled]="loading" (click)="cambiarFechaReporte()">
                  <i ngbTooltip="Cambiar la fecha del reporte" class="fa fa-pencil" aria-hidden="true"></i>
                </button>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
      <ng-container *ngIf="loading">
        <div class="spinner-container">
          <ngx-spinner name="spinnerParteDiario" bdOpacity=0.3bd
          Color="rgba(193,193,193,0)" size="medium" color="#185db5" type="ball-grid-beat" [fullScreen]="false">
          <p style="color: white">{{message}} </p>
        </ngx-spinner>
          
        </div>
      </ng-container>
      <ng-container *ngIf="!loading && parteDiario">
        <ng-container *ngIf="this.parteDiario?.detallesParteDiario.length > 0">
          <div class="row">
            <div class="mb-3 col-md-6">
              <table style="width:100%; font-size:12px; border-collapse:collapse;" class="table text-center" border="1">
                <tr class="titulo bordes">
                            <th class="bordes" colspan="3">Informaci&oacute;n para ruteo</th>
                </tr>
                <tr class="titulo bordes">
                  <th class="bordes" rowspan="2">Producto</th>
                            <th class="bordes" rowspan="2">Vac&iacute;o (lt)</th>
                  <th class="bordes">Volumen Solicitado (lt)</th>
                </tr>
                <tbody>
                  <ng-container *ngFor="let d of this.parteDiario.detallesParteDiario; trackBy: trackFn">
                    <tr class="bordes">
                      <td class="bordes" [ngStyle]="{'background-color': d.colorProducto, 'color': '#ffff', 'font-weight': 'bold'}">
                        {{d.nombreProducto}}
                      </td>
                      <td class="bordes">{{ d.vacio | number:'0.0-0' }}</td>
                      <td class="bordes">{{ d.cantidadEnPedidos | number:'0.0-0' }}</td>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
            </div>
            <div class="mb-3 col-md-6">
              <table style="width:100%; font-size:12px; border-collapse:collapse;" class="table text-center" border="1">
                <tr class="titulo bordes">
                            <th class="bordes" colspan="4">Proyecci&oacute;n al {{ this.fechaProyeccion | date: "d'/'MM'/'y'" }}
                            </th>
                </tr>
                <tr class="titulo bordes">
                  <th class="bordes" rowspan="2">Producto</th>
                  <th class="bordes" rowspan="2">Stock Operativo (lt)</th>
                  <th class="bordes" rowspan="2">Salida estimada (lt)</th>
                  <th class="bordes" rowspan="2">Stock (D&iacute;as)</th>
                </tr>
                <tbody>
                  <ng-container *ngFor="let d of this.parteDiario.detallesParteDiario; let i = index; trackBy: trackFn">
                    <tr class="bordes">
                      <td class="bordes" [ngStyle]="{'background-color': d.colorProducto, 'color': '#ffff', 'font-weight': 'bold'}">
                        {{d.nombreProducto}}
                      </td>
                      <td class="bordes">{{ d.stockOperativo | number:'0.0-0' }}</td>
                      <td class="bordes">
                        <ng-container *ngIf="!reporteParteDiario">
                          <input class="form-control" appOnlyNumber (keyup)="changeValue(i, 'salidaEstimada', $event)" [value]="d.salidaEstimada">
                          <ng-container *ngIf="isVacio(i, 'salidaEstimada')">
                            <div class="alert alert-danger">Requerido</div>
                          </ng-container>
                        </ng-container>
                        <ng-container *ngIf="reporteParteDiario">
                          {{ d.salidaEstimada | number:'0.0-0' }}
                        </ng-container>
                      </td>
                      <td class="bordes">{{ d.stockEnDias==0 ? '-' : d.stockEnDias | number:'1.2-2' }}</td>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
            </div>
          </div>
          <div class="row">
            <div class="mb-3 col-md-12">
              <div class="bordes">
               
                        <label style="margin-bottom: 0;" class="col-md-12 titulo"><b>Novedades operativas</b></label>
                        @if(!reporteParteDiario) {
                        <label style="margin-bottom: 0;" class="col-md-12 titulo">(Demoras,
                            Reclamos, Reprogramaciones, Cancelaciones, Notas Recibidas, Inconvenientes en facturaci&oacute;n,
                            NOTAM
                            activo, Visitas Recibidas, etc.)</label>

                        <textarea [formControl]="novedadesFormControl" name="novedades" id="novedades"
                            style="width: 100%; border: 0;" rows="3" placeholder="Observaci&oacute;n...">
                                </textarea>

                        }
                        @if(reporteParteDiario) {
                  {{ this.parteDiario.novedadesOperativas }}
                          }              
              </div>
            </div>
          </div>
          <div class="row">
            <div class="mb-3 col-md-6">
              <table style="width:100%; font-size:12px; border-collapse:collapse;" class="table text-center" border="1">
                <tr class="titulo bordes">
                            <th class="bordes" colspan="8">Operaciones del d&iacute;a {{ this.fechaHoraReporte | date:
                                "d'/'MM'/'y'" }}</th>
                </tr>
                <tr class="titulo bordes">
                  <th class="bordes">Producto</th>
                  <th class="bordes">Operaciones intoplane</th>
                  <th class="bordes">Remitos Cargamento</th>
                  <th class="bordes">Operaciones granel</th>
                  <th class="bordes">Consumo interno</th>
                  <th class="bordes">Total operaciones</th>
                  <th class="bordes">Volumen despachado (lt)</th>
                  <th class="bordes">Volumen ingresado (lt)</th>
                </tr>
                <tbody>
                  <ng-container *ngFor="let d of this.parteDiario.detallesParteDiario; trackBy: trackFn">
                    <tr class="bordes">
                      <td class="bordes" [ngStyle]="{'background-color': d.colorProducto, 'color': '#ffff', 'font-weight': 'bold'}">
                        {{d.nombreProducto}}
                      </td>
                      <td class="bordes">{{ d.cantidadRemitoNoGranel | number:'0.0-0' }}</td>
                      <td class="bordes">{{ d.cantidadRemitoSalida | number:'0.0-0' }}</td>
                      <td class="bordes">{{ d.cantidadRemitoGranel | number:'0.0-0' }}</td>
                      <td class="bordes">{{ d.cantidadRemitoConsumoInterno | number:'0.0-0' }}</td>
                      <td class="bordes">{{ d.cantidadRemitoNoGranel + d.cantidadRemitoSalida + d.cantidadRemitoGranel + d.cantidadRemitoConsumoInterno | number:'0.0-0' }}</td>
                      <td class="bordes">{{ d.volumenDespachado | number:'0.0-0' }}</td>
                      <td class="bordes">{{ d.volumenIngresado | number:'0.0-0' }}</td>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
            </div>
            <div class="mb-3 col-md-6">
              <table style="width:100%; font-size:12px; border-collapse:collapse;" class="table text-center" border="1">
                <tr class="titulo bordes">
                  <th class="bordes" colspan="6">Resumen de novedades</th>
                </tr>
                <tr class="titulo bordes">
                  <th class="bordes" rowspan="2">Producto</th>
                  <th class="bordes" rowspan="2">UUAA operativas</th>
                  <th class="bordes" rowspan="2">UUAA F/S Correctivo/Preventivo</th>
                            <th class="bordes" rowspan="2">UUAA F/S por reparaci&oacute;n mayor</th>
                  <th class="bordes" colspan="1">Demoras por problemas propios</th>
                  <th class="bordes" colspan="1">Demoras por problemas de las Líneas Aéreas</th>
                </tr>
                
                        <tr class="titulo bordes">
                            <th class="bordes">Por problemas propios</th>
                            <th class="bordes">Por problemas de las L&iacute;neas A&eacute;reas</th>
                        </tr>

                <tbody>
                  <ng-container *ngFor="let d of this.parteDiario.detallesParteDiario; let i = index; trackBy: trackFn">
                    <tr class="bordes">
                      <td class="bordes" [ngStyle]="{'background-color': d.colorProducto, 'color': '#ffff', 'font-weight': 'bold'}">
                        {{d.nombreProducto}}
                      </td>
                      <td class="bordes">{{ d.cantAbastecedorasEnServicio }}</td>
                      <td class="bordes">{{ d.cantAbastecedorasFS }}</td>
                      <td class="bordes">{{ d.cantAbastecedorasReparacion }}</td>
                      <td class="bordes">
                        <ng-container *ngIf="!reporteParteDiario">
                          <input class="form-control" appOnlyNumber (keyup)="changeValue(i, 'demorasProblemasPropios', $event)" [value]="d.demorasProblemasPropios">
                          <ng-container *ngIf="isVacio(i, 'demorasProblemasPropios')">
                            <div class="alert alert-danger">Requerido</div>
                          </ng-container>
                        </ng-container>
                        <ng-container *ngIf="reporteParteDiario">
                          {{ d.demorasProblemasPropios }}
                        </ng-container>
                      </td>
                      <td class="bordes">
                        <ng-container *ngIf="!reporteParteDiario">
                          <input class="form-control" appOnlyNumber (keyup)="changeValue(i, 'demorasLineasAereas', $event)" [value]="d.demorasLineasAereas">
                          <ng-container *ngIf="isVacio(i, 'demorasLineasAereas')">
                            <div class="alert alert-danger">Requerido</div>
                          </ng-container>
                        </ng-container>
                        <ng-container *ngIf="reporteParteDiario">
                          {{ d.demorasLineasAereas }}
                        </ng-container>
                      </td>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
            </div>
          </div>
          <ng-container *ngIf="this.parteDiario?.detallesParteDiario.length == 0">
            <ngb-alert class="alert-warning">
              No hay detalle de productos configurados para esta aeroplanta.
            </ngb-alert>
          </ng-container>
          <div class="row">
            <div class="mb-3 col-md-6">
              <table style="width:100%; font-size:12px; border-collapse:collapse;" class="table text-center" border="1">
                <tr class="titulo bordes">
                  <th class="bordes" colspan="8">Tanques</th>
                </tr>
                <tr class="titulo bordes">
                  <th class="bordes">TK</th>
                  <th class="bordes">Producto</th>
                  <th class="bordes">Cap. (lt)</th>
                  <th class="bordes">Estado</th>
                            <th class="bordes">Telemedici&oacute;n</th>
                  <th class="bordes">Existencia (lt)</th>
                  <th class="bordes">Fecha cambio de estado</th>
                  <th class="bordes">Motivo</th>
                </tr>
                <tbody>
                  <ng-container *ngFor="let t of this.parteDiario.estadosTanques; let i = index; trackBy: trackFn">
                    <tr class="bordes">
                      <td class="bordes" [ngStyle]="{'background-color': t.colorProducto, 'color': '#ffff', 'font-weight': 'bold'}">
                        {{t.codigoContenedor}}
                      </td>
                      <td class="bordes">{{t.nombreProducto}}</td>
                      <td class="bordes">{{t.capacidad | number:'0.0-0'}}</td>
                      <td class="bordes">
                        <ng-container *ngIf="servicioSeleccionado===i && editandoTanque">
                          <loading-text-spinner message="Guardando cambios..." color="primary"></loading-text-spinner>
                        </ng-container>
                        <ng-container *ngIf="!reporteParteDiario && (servicioSeleccionado!==i && editandoTanque || !editandoTanque)">
                          <select class="form-select" style="font-size:12px;" [disabled]="servicioSeleccionado!==i && editandoTanque" [ngClass]="{'verde': t.estadoServicio===EstadoTanqueUnico.EnServicio, 'rojo': t.estadoServicio===EstadoTanqueUnico.FueraServicio}" (change)="cambiarEstadoServicioTanques(t, i)" [(ngModel)]="t.estadoServicio">
                            <ng-container *ngFor="let estado of keysEstadoTanqueUnico(); trackBy: trackFn">
                              <option [ngValue]="EstadoTanqueUnico[estado]">{{ estado }}</option>
                            </ng-container>
                          </select>
                        </ng-container>
                        <ng-container *ngIf="reporteParteDiario">
                          {{ EstadoTanqueUnico[t.estadoServicio] }}
                        </ng-container>
                      </td>
                      <td class="bordes">
                        <ng-container *ngIf="telemedicionSeleccionada===i && editandoTanque">
                          <loading-text-spinner message="Guardando cambios..." color="primary"></loading-text-spinner>
                        </ng-container>
                        <ng-container *ngIf="!reporteParteDiario && (telemedicionSeleccionada!==i && editandoTanque || !editandoTanque)">
                          <select class="form-select" style="font-size:12px;" [disabled]="telemedicionSeleccionada!==i && editandoTanque || reporteParteDiario" [ngClass]="{'verde': t.estadoTelemedicion===EstadoTelemedicion.EnServicio, 'rojo': t.estadoTelemedicion===EstadoTelemedicion.FueraServicio}" (change)="cambiarEstadoTelemedicionTanques(t, i)" [(ngModel)]="t.estadoTelemedicion">
                            <ng-container *ngFor="let estado of keysEstadoTelemedicion(); trackBy: trackFn">
                              <option [ngValue]="EstadoTelemedicion[estado]">{{ estado }}</option>
                            </ng-container>
                          </select>
                        </ng-container>
                        <ng-container *ngIf="reporteParteDiario">
                          {{ EstadoTelemedicion[t.estadoTelemedicion] }}
                        </ng-container>
                      </td>
                      <td class="bordes">{{t.existenciaAlCierre | number:'0.0-0'}}</td>
                      <td class="bordes">{{t.fechaHoraFS | date:"d'/'MM'/'y' 'hh:mm a"}}</td>
                      <td class="bordes">
                        <ng-container *ngIf="t.observaciones !== ''">
                          <button class="btn btn-sm" [popoverTitle]="titulo" [ngbPopover]="contenido">
                            <i ngbTooltip="Ver motivos" class="fa fa-eye" aria-hidden="true"></i>
                          </button>
                          <ng-template #titulo>Motivo:</ng-template>
                          <ng-template #contenido>{{ t.observaciones }}</ng-template>
                        </ng-container>
                      </td>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
            </div>
            <div class="mb-3 col-md-6">
              <table style="width:100%; font-size:12px; border-collapse:collapse;" class="table text-center" border="1">
                <tr class="titulo bordes">
                  <th class="bordes" colspan="6">Unidades abastecedoras/surtidores</th>
                </tr>
                <tr class="titulo bordes">
                  <th class="bordes">Equipo</th>
                  <th class="bordes">Producto</th>
                  <th class="bordes">Cap. (lt)</th>
                  <th class="bordes">Estado</th>
                  <th class="bordes">Fecha cambio de estado</th>
                  <th class="bordes">Motivo</th>
                </tr>
                <tbody>
                  <ng-container *ngFor="let e of this.parteDiario.estadosExpendedoras; let i = index; trackBy: trackFn">
                    <tr class="bordes">
                      <td class="bordes" [ngStyle]="{'background-color': e.colorProducto, 'color': '#ffff', 'font-weight': 'bold'}">
                        {{e.codigoExpendedora}}
                      </td>
                      <td class="bordes">{{e.nombreProducto}}</td>
                      <td class="bordes">{{e.capacidad | number:'0.0-0'}}</td>
                      <td class="bordes">
                        <ng-container *ngIf="expendedoraSeleccionada===i && editandoExpendedora">
                          <loading-text-spinner message="Guardando cambios..." color="primary"></loading-text-spinner>
                        </ng-container>
                        <ng-container *ngIf="!reporteParteDiario && (expendedoraSeleccionada!==i && editandoExpendedora || !editandoExpendedora)">
                          <select class="form-select" style="font-size:12px;" [disabled]="expendedoraSeleccionada!==i && editandoExpendedora || reporteParteDiario" [ngClass]="{'verde': e.estadoServicio===EstadoServAbastecedora.EnServicio, 'rojo': e.estadoServicio===EstadoServAbastecedora.FueraServicio}" (change)="cambiarEstadoServicioExpendedoras(e, i)" [(ngModel)]="e.estadoServicio">
                            <ng-container *ngFor="let estado of keysEstadoServAbastecedora(); trackBy: trackFn">
                              <option [ngValue]="EstadoServAbastecedora[estado]">{{ estado }}</option>
                            </ng-container>
                          </select>
                        </ng-container>
                        <ng-container *ngIf="reporteParteDiario">
                          {{ EstadoServAbastecedora[e.estadoServicio] }}
                        </ng-container>
                      </td>
                      <td class="bordes">{{e.fechaHoraFS | date:"d'/'MM'/'y' 'hh:mm a"}}</td>
                      <td class="bordes">
                        <ng-container *ngIf="e.observaciones !== ''">
                          <button class="btn btn-sm" [popoverTitle]="titulo" [ngbPopover]="contenido">
                            <i ngbTooltip="Ver motivos" class="fa fa-eye" aria-hidden="true"></i>
                          </button>
                          <ng-template #titulo>Motivo:</ng-template>
                          <ng-template #contenido>{{ e.observaciones }}</ng-template>
                        </ng-container>
                      </td>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
            </div>
          </div>
          <ng-container *ngIf="this.parteDiario?.equiposFijos.length > 0">
            <div class="row">
              <div class="mb-3 col-md-12">
                <table class="table text-center" style="width:100%; font-size:12px; border-collapse:collapse;" border="1">
                  <tr class="titulo bordes">
                    <th class="bordes" colspan="4">Equipos Fijos de Planta</th>
                  </tr>
                  <tr class="titulo bordes">
                    <th class="bordes">Equipo</th>
                    <th class="bordes">Estado</th>
                    <th class="bordes">Fecha cambio de estado</th>
                    <th class="bordes">Motivo</th>
                  </tr>
                  <tbody>
                    <ng-container *ngFor="let ef of this.parteDiario.equiposFijos; let i = index; trackBy: trackFn">
                      <tr class="bordes">
                        <td class="bordes">{{ef.nombre}}</td>
                        <td class="bordes">
                          <ng-container *ngIf="equipoSeleccionado===i && editandoEquipo">
                            <loading-text-spinner message="Guardando cambios..." color="primary"></loading-text-spinner>
                          </ng-container>
                          <ng-container *ngIf="!reporteParteDiario && (equipoSeleccionado!==i && editandoEquipo || !editandoEquipo)">
                            <select class="form-select" style="font-size:12px;" [disabled]="equipoSeleccionado!==i && editandoEquipo || reporteParteDiario" [ngClass]="{'verde': ef.estado===estadoEquipo.EnServicio, 'rojo': ef.estado===estadoEquipo.FueraDeServicio}" (change)="cambiarEstadoEquipos(ef.idStock, ef.estado, i)" [(ngModel)]="ef.estado">
                              <ng-container *ngFor="let estado of keysEstadoEquipo(); trackBy: trackFn">
                                <option [ngValue]="estadoEquipo[estado]">{{ estado }}</option>
                              </ng-container>
                            </select>
                          </ng-container>
                          <ng-container *ngIf="reporteParteDiario">
                            {{ estadoEquipo[ef.estado] }}
                          </ng-container>
                        </td>
                        <td class="bordes">{{ef.fechaHoraFS | date:"d'/'MM'/'y' 'hh:mm a"}}</td>
                        <td class="bordes">
                          <ng-container *ngIf="ef.observaciones !== ''">
                            <button class="btn btn-sm" [popoverTitle]="titulo" [ngbPopover]="contenido">
                              <i ngbTooltip="Ver motivos" class="fa fa-eye" aria-hidden="true"></i>
                            </button>
                            <ng-template #titulo>Motivo:</ng-template>
                            <ng-template #contenido>{{ ef.observaciones }}</ng-template>
                          </ng-container>
                        </td>
                      </tr>
                    </ng-container>
                  </tbody>
                </table>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="this.parteDiario?.equiposFijos.length == 0">
            <ngb-alert class="alert-warning">
              No hay equipos fijos configurados para esta aeroplanta.
            </ngb-alert>
          </ng-container>
          <div class="row">
            <!-- sexta linea -->
            @if(this.parteDiario?.sistemasSeguridad.length > 0) {
            <div class="row col-md-12">
                <div class="mb-3 col-md-12">
                    <table class="table text-center">

                        <tr class="titulo bordes">
                            <th class="bordes" colspan="5">Sistema de protecci&oacute;n de seguridad (SPS)</th>
                        </tr>

                        <tr class="titulo bordes">
                            <th class="bordes">Equipo</th>
                            <th class="bordes">Estado</th>
                            <th class="bordes">Fecha cambio de estado</th>
                            <th class="bordes">Autorizador</th>
                            <th class="bordes">Motivo</th>
                        </tr>

                        <tbody>
                            @for (ss of this.parteDiario.sistemasSeguridad; let i = $index; track $index) {
                                <tr class="bordes">
                                    <td class="bordes">{{ss.nombre}}</td>
                                    <td class="bordes">
                                        @if(sistemaSeleccionado==i && editandoSistema) {
                                        <loading-text-spinner message="Guardando cambios..." color="primary">
                                        </loading-text-spinner>
                                        }

                                        @if(!reporteParteDiario && (sistemaSeleccionado!=i && editandoSistema ||
                                        !editandoSistema)) {
                                        <select type="text" class="form-select" id="estadoSistemaSeg"
                                            [disabled]="sistemaSeleccionado!=i && editandoSistema || this.reporteParteDiario"
                                            [ngClass]="{'verde':ss.estado==estadoSistemaSeg.EnServicio, 'rojo':ss.estado==estadoSistemaSeg.FueraDeServicio}"
                                            (change)="cambiarEstadoSistemas(ss.idStock, ss.estado, i)"
                                            [(ngModel)]="ss.estado">
                                            @for (estado of keysEstadoSistema(); track $index) {
                                            <option id="estadoSistemaSeg" [ngValue]="estadoSistemaSeg[estado]">
                                                {{ estado }}
                                            </option>
                                            }
                                        </select>
                                        }
                                        @if(reporteParteDiario) {
                                        {{ estadoSistemaSeg[ss.estado] }}
                                        }
                                    </td>
                                    <td class="bordes">{{ss.fechaHoraFS | date: "d'/'MM'/'y' 'hh:mm a"}}</td>
                                    <td class="bordes">{{ss.autorizoFS}}</td>
                                    <td class="bordes">
                                        @if(ss.observaciones != '' ) {
                                        <button class="btn btn-sm" [popoverTitle]="titulo" [ngbPopover]="contenido">
                                            <i ngbTooltip="Ver motivos" class="fa fa-eye" aria-hidden="true"></i>
                                        </button>

                                        <ng-template #titulo>Motivo:</ng-template>
                                        <ng-template #contenido>{{ ss.observaciones }}</ng-template>
                                        }
                                    </td>
                                </tr>
                            }
                        </tbody>
                    </table>
                </div>
            </div>
            }
            @if(this.parteDiario?.equiposFijos.length == 0 ) {
            <ngb-alert class="alert-warning">
                No hay sistemas de seguridad configurados para esta aeroplanta.
            </ngb-alert>
            }

            <!-- septima linea -->
            <div class="row col-md-12">
            <div class="mb-3 col-md-12">
              <table class="table text-center" style="width:100%; font-size:12px; border-collapse:collapse;" border="1">
                <tr class="titulo bordes">
                  <th class="bordes"></th>
                  <th class="bordes">Detalle</th>

                            <th class="bordes">N&uacute;mero de Contacto</th>
                            <th class="bordes">Correo Electr&oacute;nico</th>
                </tr>
                <tbody>
                  <tr>
                    <td class="bordes">Operador Responsable</td>
                    <td class="bordes">{{this.cierreTurno?.responsable}}</td>
                    <td class="bordes"></td>
                    <td class="bordes"></td>
                  </tr>
                            @for(operador of this.parteDiario.firmasOperadoras; let i = $index; track operador) {
                                <tr>
                                    <td class="bordes">Firma Operador </td>
                                    <td class="bordes">{{operador.nombre}}</td>
                                    <td class="bordes">{{operador.numero}}</td>
                                    <td class="bordes">{{operador.email}}</td>
                                </tr>
                            }
                            @for(operador of this.parteDiario.referentesTecnicos; let i = $index; track operador) {
                                <tr>
               
                                    <td class="bordes">Referente T&eacute;cnico</td>
                                    <td class="bordes">{{operador.nombre}}</td>
                                    <td class="bordes">{{operador.numero}}</td>
                                    <td class="bordes">{{operador.email}}</td>
                                </tr>
                            }
                            @for(operador of this.parteDiario.referentesGestion; let i = $index; track operador) {
                                <tr>
                
                                    <td class="bordes">Referente Gesti&oacute;n</td>
                                    <td class="bordes">{{operador.nombre}}</td>
                                    <td class="bordes">{{operador.numero}}</td>
                                    <td class="bordes">{{operador.email}}</td>
                                </tr>
                            }
                            @for (operador of this.parteDiario.referentesComerciales; let i = $index; track operador) {
                                <tr>
                  <td class="bordes"> Referente Comercial </td>
                                    <td class="bordes">{{operador.nombre}}</td>
                                    <td class="bordes">{{operador.numero}}</td>
                                    <td class="bordes">{{operador.email}}</td>
                                </tr>
                            }
                            @for(operador of this.parteDiario.ruteadores; let i = $index; track operador) {
                                <tr>

                                    <td class="bordes">Ruteador </td>
                                    <td class="bordes">{{operador.nombre}}</td>
                                    <td class="bordes">{{operador.numero}}</td>
                                    <td class="bordes">{{operador.email}}</td>
                                </tr>
                            }
                        </tbody>
              </table>
            </div>
          </div>
          <div class="row">
            <div class="mb-3 col-md-12">
              <table class="table text-center" style="width:100%; font-size:12px; border-collapse:collapse;" border="1">
                <tr class="titulo bordes">
                            <th class="bordes">ESTA PLANILLA TIENE CAR&Aacute;CTER DE DECLARACION JURADA </th>
                </tr>
              </table>
            </div>
          </div>
        <ng-container *ngIf="!this.loading && !getNotIsNullOrUndefined(this.parteDiario)">
          <ngb-alert class="alert-warning">
                Error: El parte diario no fue generado con &eacute;xito.
          </ngb-alert>
        </ng-container>
        <ng-container *ngIf="this.actualizarParteDiario">
          <ngb-alert class="alert-danger text-center">
            El parte diario ha sido modificado, se necesita actualizar.
          </ngb-alert>
        </ng-container>
    <ng-container *ngIf="!this.reporteParteDiario && getNotIsNullOrUndefined(this.parteDiario) && this.parteDiario?.detallesParteDiario.length > 0">
      <div class="card-footer">
        <div class="float-end">
          <button class="btn btn-primary" type="button" (click)="finalizarTurno()" [disabled]="guardando || actualizarParteDiario || actualizando">
            <ng-container *ngIf="!guardando">Finalizar turno</ng-container>
            <ng-container *ngIf="guardando">
              <div class="d-flex align-items-center">
                <div class="spinner-border text-light spinner-border-sm" role="status"></div>
                <span>Finalizando...</span>
              </div>
            </ng-container>
          </button>
        </div>
        <ng-container *ngIf="!actualizarParteDiario">
          <div class="float-end me-2">
            <button class="btn btn-primary" type="button" (click)="guardarClick()" [disabled]="generando || guardando || actualizando">
              <ng-container *ngIf="!generando">Guardar Parte Diario</ng-container>
              <ng-container *ngIf="generando">
                <div class="d-flex align-items-center">
                  <div class="spinner-border text-light spinner-border-sm" role="status"></div>
                  <span>Guardando...</span>
                </div>
              </ng-container>
            </button>
          </div>
        </ng-container>
        <ng-container *ngIf="actualizarParteDiario">
          <div class="float-end me-2">
            <button class="btn btn-primary" type="button" (click)="actualizarParte();" [disabled]="generando || guardando">
              <ng-container *ngIf="!actualizando">Guardar y Actualizar Parte Diario</ng-container>
              <ng-container *ngIf="actualizando">
                <div class="d-flex align-items-center">
                  <div class="spinner-border text-light spinner-border-sm" role="status"></div>
                  <span>Actualizando...</span>
                </div>
              </ng-container>
            </button>
          </div>
        </ng-container>
      </div>
    </ng-container>
  </div>
  